var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "c-tabber" },
    [
      _vm._l(_vm.tabs, function(tab) {
        return _c(
          "div",
          {
            key: tab.value,
            ref: tab.value,
            refInFor: true,
            class: _vm.getClasses(tab),
            attrs: { "data-cy": "tab" },
            on: {
              click: function($event) {
                return _vm.$emit("change-tab", tab.value)
              }
            }
          },
          [
            tab.icon
              ? _c("k-icon", {
                  staticClass: "icon",
                  attrs: { icon: tab.icon, size: "20" }
                })
              : _vm._e(),
            _vm._v(" "),
            _c("span", { staticClass: "text" }, [_vm._v(_vm._s(tab.name))])
          ],
          1
        )
      }),
      _vm._v(" "),
      _c("div", { staticClass: "toggle", style: _vm.toggleStyle })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-684ff547", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-684ff547","hasScoped":false,"transformToRequire":{"img":"src","image":"xlink:href","cimage":"placeholder","c-image":"placeholder","CImage":"placeholder"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/CComponents/CTabber.vue
// module id = 2232
// module chunks = 1610